/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1InterestagesQueryResponse } from '../../types/GetV1Interestages.ts'

export const getV1InterestagesQueryKey = () => [{ url: '/v1/InterestAges' }] as const

export type GetV1InterestagesQueryKey = ReturnType<typeof getV1InterestagesQueryKey>

/**
 * {@link /v1/InterestAges}
 */
export async function getV1Interestages(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1InterestagesQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/InterestAges`,
        ...requestConfig,
    })
    return res
}

export function getV1InterestagesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1InterestagesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1InterestagesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1InterestagesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Interestages(config)
        },
    })
}

/**
 * {@link /v1/InterestAges}
 */
export function useGetV1Interestages<
    TData = ResponseConfig<GetV1InterestagesQueryResponse>,
    TQueryData = ResponseConfig<GetV1InterestagesQueryResponse>,
    TQueryKey extends QueryKey = GetV1InterestagesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1InterestagesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1InterestagesQueryKey()

    const query = useQuery(
        {
            ...getV1InterestagesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
